'use strict';

const region = [
  {
    name: '北海道',
    color: 'deep-purple darken-1',
  },
  {
    name: '東北地方',
    color: 'indigo darken-1',
  },
  {
    name: '関東地方',
    color: 'teal darken-1',
  },
  {
    name: '中部地方',
    color: 'light-green darken-1',
  },
  {
    name: '近畿地方',
    color: 'amber darken-1',
  },
  {
    name: '中国地方',
    color: 'deep-orange darken-1',
  },
  {
    name: '四国地方',
    color: 'pink lighten-1',
  },
  {
    name: '九州地方',
    color: 'red darken-1',
  },
];

export default {
  /**
   * 引数の県に応じた地方を取得する
   * @param prefecture {String} - prefecture number
   * @returns regionData {Object} - region name, region color
   */
  getRegion: prefecture => {
    const prefectureNum = parseInt(prefecture, 10);

    if (prefectureNum === 1) return region[0];
    else if (prefectureNum <= 7) return region[1];
    else if (prefectureNum <= 14) return region[2];
    else if (prefectureNum <= 23) return region[3];
    else if (prefectureNum <= 30) return region[4];
    else if (prefectureNum <= 35) return region[5];
    else if (prefectureNum <= 39) return region[6];
    else if (prefectureNum <= 47) return region[7];
  },
};
